import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { postDataFromApi, putDataFromApi } from "../../../services/commonServices";
import { ccUpdateApi, creditNoteUpdateApi, InternalCertificateUpdateApi, JRFUpdateApi, purchaseOrderUpdateApi, purchaseRequistionUpdateApi } from "../../../services/api";


/**
 * Countdown Toast Component
 */
const UndoToast = ({
  successMsg,
  seconds = 30,
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData,
  onUndoClick,
  callbackFunc = null

}) => {

  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {

    if (timeLeft <= 0) {
      handleNavigateURL(moduleType, navigate, callbackFunc);
      toast.dismiss();
      return;
    }

    const timer = setTimeout(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);

  }, [timeLeft]);


  return (
    <span style={{ display: "flex", flexDirection: "column" }}>

      <span style={{ fontWeight: "500" }}>
        {successMsg}
      </span>

      <span style={{ fontSize: "12px", color: "#6c757d", marginTop: "2px" }}>
        Click Undo to revert this action.
      </span>

      <span
        style={{
          marginTop: "6px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          fontSize: "13px"
        }}
      >

        <button
          type="button"
          onClick={() => {
            onUndoClick();
            handleUndoLastChanges(
              ModuleID,
              setIsOverlayLoader,
              navigate,
              moduleType,
              formData,
              callbackFunc
            );
            if (!['purchaseOrder', 'purchaseReq'].includes(moduleType)) {
              toast.dismiss();
            }

          }}
          style={{
            border: "none",
            background: "none",
            color: "#0d6efd",
            cursor: "pointer",
            fontWeight: "600",
            textDecoration: "underline"
          }}
        >
          Undo
        </button>

        <span style={{ color: "#ccc" }}>|</span>

        <span
          style={{
            color: timeLeft <= 5 ? "#dc3545" : "#6c757d"
          }}
        >
          Redirecting in {timeLeft}s
        </span>

      </span>

    </span>
  );
};



/**
 * Common function
 */
export const handleCommonUndoLastChanges = (
  successMsg,
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType = "",
  formData,
  callbackFunc = null
) => {
  let isUndoClicked = false; // 🔥 flag
  toast.success(

    <UndoToast
      successMsg={successMsg}
      seconds={30}
      ModuleID={ModuleID}
      setIsOverlayLoader={setIsOverlayLoader}
      navigate={navigate}
      moduleType={moduleType}
      formData={formData}
      onUndoClick={() => {
        isUndoClicked = true; // 🔥 set flag
      }}
    />,

    {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      onClose: () => {
        if (!isUndoClicked) {
          handleNavigateURL(moduleType, navigate, callbackFunc);
        }
      }
    }
  );

};



/**
 * navigation handler
 */
const handleNavigateURL = (moduleType, navigate, callbackFunc) => {
  switch (moduleType) {
    case "jrf":
      navigate("/jrfListing");
      break;
    case "commercialcertificate":
      if (callbackFunc) {
        callbackFunc()
      }
      else {
        navigate("/operation/commercial-certificate-list");
      }
      break;
    case "purchaseOrder":
      navigate("/purchase");
      break;
    case "purchaseReq":
      if (callbackFunc) {
        callbackFunc()
      }
      else {
        navigate("/PurchRequistion");
      }
      break;
    case "creditNoteModule":
      navigate("/collections/credit-notes");
      break;
    case "internal_certificate":
      navigate("/testReport");
      break;
    default:
      break;
  }
};



/**
 * JRF undo
 */
export const handleJRFUndoApproval = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType
) => {

  try {

    setIsOverlayLoader(true);

    const MainData = {
      jrf_id: ModuleID,
      jrf_data: {
        jrf_status: "saved"
      }
    };

    const res = await putDataFromApi(JRFUpdateApi, MainData);

    if (res?.data?.status === 200) {

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => {
        handleNavigateURL(moduleType, navigate);
      }, 1000);

    }
    else {

      toast.error(res?.data?.message || "Undo failed");

    }

  }
  catch (error) {

    toast.error("Something went wrong");

  }
  finally {

    setIsOverlayLoader(false);

  }

};
export const handleCCUndoApproval = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData,
  callbackFunc
) => {
  try {
    setIsOverlayLoader(true);
    let status = ""
    if (formData.status === "sent_for_approval") {
      status = "posted"
    }
    else {
      status = "sent_for_approval"
    }
    let payload = {
      cc_id: ModuleID,
      commercial_certificate: {
        status: status,
      },
    };
    let res = await putDataFromApi(ccUpdateApi, payload);

    if (res?.data?.status === 200) {

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => {
        handleNavigateURL(moduleType, navigate);
      }, 1000);

    }
    else {

      toast.error(res?.data?.message || "Undo failed");

    }

  }
  catch (error) {

    toast.error("Something went wrong");

  }
  finally {

    setIsOverlayLoader(false);

  }

};
export const handlePOUndoApproval = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData
) => {

  try {
    setIsOverlayLoader(true);

    let payload = {
      po_id: ModuleID,
      po_status: formData[0]?.po_status ? formData[0]?.po_status : "Saved"
    };
    if (payload.po_status === "Saved") {
      payload.fk_approval_id = ""
    }
    let res = await postDataFromApi(purchaseOrderUpdateApi(ModuleID), payload);

    if (res?.data?.status === 200) {

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => {
        handleNavigateURL(moduleType, navigate);
      }, 1000);

    }
    else {

      toast.error(res?.data?.message || "Undo failed");

    }

  }
  catch (error) {

    toast.error("Something went wrong");

  }
  finally {

    setIsOverlayLoader(false);

  }

};
export const handlePRUndoApproval = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData
) => {

  try {

    setIsOverlayLoader(true);

    let payload = {
      req_no: ModuleID,
      req_status: formData?.[0]?.req_status ? formData?.[0]?.req_status : "Posted"
    };
    if (payload.req_status === "Posted") {
      payload.req_fk_approval_id = ""
    }
    let updatePurchase = purchaseRequistionUpdateApi(ModuleID);
    let res = await postDataFromApi(updatePurchase, payload);

    if (res?.data?.status === 200) {

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => {
        handleNavigateURL(moduleType, navigate);
      }, 1000);

    }
    else {

      toast.error(res?.data?.message || "Undo failed");

    }

  }
  catch (error) {
    console.log('---errr---', error)
    toast.error("Something went wrong");

  }
  finally {

    setIsOverlayLoader(false);

  }

};
export const handleCNUndoApproval = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData
) => {

  try {

    setIsOverlayLoader(true);

    let MainData = {
      cn_status: formData[0]?.cn_status ? formData[0]?.cn_status : "saved",
      cn_next_approval_role: formData[0]?.cn_next_approval_role,
      action: "approval_retrieval"
    };
    let res = await putDataFromApi(
      creditNoteUpdateApi(ModuleID),
      MainData,
    );

    if (res?.data?.status === 200) {

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => {
        handleNavigateURL(moduleType, navigate);
      }, 1000);

    }
    else {

      toast.error(res?.data?.message || "Undo failed");

    }

  }
  catch (error) {

    toast.error("Something went wrong");

  }
  finally {

    setIsOverlayLoader(false);

  }

};
export const handleICUndoApproval = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData
) => {

  try {

    setIsOverlayLoader(true);

    let ic_data = {
      status: formData[0]?.status ? formData[0]?.status : "saved",
    };
    let MainData = {
      ic_id: ModuleID,
      ic_data: ic_data,
    };
    let res = await putDataFromApi(
      InternalCertificateUpdateApi,
      MainData,
    );

    if (res?.data?.status === 200) {

      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000
      });

      setTimeout(() => {
        handleNavigateURL(moduleType, navigate);
      }, 1000);

    }
    else {

      toast.error(res?.data?.message || "Undo failed");

    }

  }
  catch (error) {

    toast.error("Something went wrong");

  }
  finally {

    setIsOverlayLoader(false);

  }

};
/**
 * module switch handler
 */
const handleUndoLastChanges = async (
  ModuleID,
  setIsOverlayLoader,
  navigate,
  moduleType,
  formData,
  callbackFunc
) => {

  switch (moduleType) {

    case "jrf":
      await handleJRFUndoApproval(
        ModuleID,
        setIsOverlayLoader,
        navigate,
        moduleType
      );
      break;
    case "commercialcertificate":
      await handleCCUndoApproval(
        ModuleID,
        setIsOverlayLoader,
        navigate,
        moduleType,
        formData,
        callbackFunc
      );
      break;
    case "purchaseOrder":
      await handlePOUndoApproval(
        ModuleID,
        setIsOverlayLoader,
        navigate,
        moduleType,
        formData
      );
      break;
    case "purchaseReq":
      await handlePRUndoApproval(
        ModuleID,
        setIsOverlayLoader,
        navigate,
        moduleType,
        formData
      );
      break;
    case "creditNoteModule":
      await handleCNUndoApproval(
        ModuleID,
        setIsOverlayLoader,
        navigate,
        moduleType,
        formData
      );
      break;
    case "internal_certificate":
      await handleICUndoApproval(
        ModuleID,
        setIsOverlayLoader,
        navigate,
        moduleType,
        formData
      );
      break;
    default:
      break;
  }

};